import { render, staticRenderFns } from "./PrintersLoader.vue?vue&type=template&id=f5d79464&scoped=true&"
import script from "./PrintersLoader.vue?vue&type=script&lang=js&"
export * from "./PrintersLoader.vue?vue&type=script&lang=js&"
import style0 from "./PrintersLoader.vue?vue&type=style&index=0&id=f5d79464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d79464",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/PrintersLoader.vue
// module id = null
// module chunks = 